import React from "react";
import Radio from "@material-ui/core/Radio";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DatePicker from "react-datepicker";
import Slider from "@material-ui/core/Slider";
import cs from "classnames";

import * as actions from "../../../actions";
import { Context } from "../../../context";
import Input from "../../Input";
import Select from "../../Select";
import Icons from "./icons";
import moment from "moment";

function dateFormat(date) {
  return moment(date)
    .utcOffset("+0000")
    .format("DD MMMM YYYY HH:mm:ss");
}

const Insurance = ({ classes, form }) => {
  const {
    state: { insurance, sports },
    dispatch,
  } = React.useContext(Context);
  const [localSports, mutateLocalSports] = React.useState(
    insurance.pickedSports
  );
  const [slider, changeSlider] = React.useState(insurance.coverage);

  React.useEffect(() => {
    actions.getSports({}, dispatch);
  }, []);

  React.useEffect(() => {
    mutateLocalSports(
      !insurance.pickedSports.length
        ? [{ id: 0, value: "" }]
        : insurance.pickedSports
    );
    console.log(insurance.pickedSports);
  }, [insurance.pickedSports.length]);

  React.useEffect(() => {
    changeSlider(insurance.coverage);
  }, [insurance.coverage]);

  const changeLocation = (locationAlpha2) => () => {
    actions.updateInsurance(
      {
        id: insurance.id,
        locationAlpha2,
      },
      dispatch
    );
  };

  const changeCoverage = (e, coverage) => {
    actions.updateInsurance(
      {
        id: insurance.id,
        coverage,
      },
      dispatch
    );
  };

  const changeCompetetion = () => {
    actions.updateInsurance(
      {
        id: insurance.id,
        isCompetition: !insurance.isCompetition,
      },
      dispatch
    );
  };

  const changePacket = (packetId) => () => {
    actions.updateInsurance(
      {
        id: insurance.id,
        packetId,
      },
      dispatch
    );
  };

  const setStartDate = (startDate) => {
    let expirationDate = moment(startDate).add(1, "days");
    if (moment(startDate).diff(moment(insurance.expirationDate), "days") < 0) {
      expirationDate = insurance.expirationDate;
    }
    actions.updateInsurance(
      {
        id: insurance.id,
        startDate,
        expirationDate,
      },
      dispatch
    );
  };

  const setEndDate = (expirationDate) => {
    console.log("hello", expirationDate.toISOString());
    actions.updateInsurance(
      {
        id: insurance.id,
        expirationDate,
      },
      dispatch
    );
  };

  const addLocalSport = () => {
    mutateLocalSports(
      localSports.concat({
        value: "",
        id: localSports.length + 1,
      })
    );
  };

  const removeLocalSport = (id) => (optionId) => {
    if (optionId) {
      actions.updateInsurance(
        {
          id: insurance.id,
          delete: { sportIds: [optionId] },
        },
        dispatch
      );
    }
    mutateLocalSports(localSports.filter((x) => x.id !== id));
  };

  const handleSelect = (option, oldSportKey) => {
    actions.updateInsurance(
      {
        id: insurance.id,
        add: {
          sportIds: [option.id],
        },
        ...(oldSportKey
          ? {
              delete: {
                sportKeys: [oldSportKey],
              },
            }
          : {}),
      },
      dispatch
    );
  };
  return (
    <React.Fragment>
      <div className={classes.item}>
        <p className={classes.itemTitle}>Срок страхования и территория</p>
        <div className={classes.dates}>
          <DatePicker
            showPopperArrow={false}
            selected={new Date(insurance.startDate)}
            locale="ru"
            dateFormat="dd-MM-yyyy"
            wrapperClassName={classes.datepickerWrapper}
            className={classes.datepickerInput}
            placeholderText="От"
            minDate={moment()
              .add(1, "days")
              .toDate()}
            onChange={setStartDate}
            customInput={<Input className={classes.input} />}
          />
          <DatePicker
            showPopperArrow={false}
            selected={new Date(insurance.expirationDate)}
            locale="ru"
            wrapperClassName={classes.datepickerWrapper}
            className={classes.datepickerInput}
            minDate={moment(insurance.startDate)
              .add(1, "days")
              .toDate()}
            maxDate={moment(insurance.startDate)
              .add(1, "years")
              .toDate()}
            placeholderText="По"
            dateFormat="dd-MM-yyyy"
            onChange={setEndDate}
            customInput={<Input className={classes.input} />}
          />
          <FormControlLabel
            value="RU"
            classes={{ root: classes.controlLabel }}
            checked={insurance.location.alpha2 === "RU"}
            control={
              <Radio
                disableRipple
                classes={{
                  root: classes.radio,
                  checked: classes.selectedRadio,
                }}
              />
            }
            label="Россия"
            onChange={changeLocation("RU")}
          />
          <FormControlLabel
            value="AA"
            classes={{ root: classes.controlLabel }}
            checked={insurance.location.alpha2 === "AA"}
            control={
              <Radio
                disableRipple
                classes={{
                  root: classes.radio,
                  checked: classes.selectedRadio,
                }}
              />
            }
            label="Весь мир, включая Россию"
            onChange={changeLocation("AA")}
          />
          <p>
            Действие с <b>{dateFormat(insurance.startDate)}</b> по{" "}
            <b>{dateFormat(insurance.expirationDate)}</b>
          </p>
        </div>
      </div>
      <div className={classes.item}>
        <div className={classes.itemTitleWrap}>
          <p className={classes.itemTitle}>Вид спорта</p>
          <FormControlLabel
            classes={{ root: classes.controlLabel }}
            control={
              <Switch
                focusVisibleClassName={classes.focusVisible}
                disableRipple
                classes={{
                  root: classes.rootSwitch,
                  switchBase: classes.switchBase,
                  thumb: classes.thumb,
                  track: classes.track,
                  checked: classes.checked,
                }}
                checked={insurance.isCompetition}
                value="competition"
                onChange={changeCompetetion}
              />
            }
            label={
              insurance.isCompetition ? "С соревнованиями" : "Без соревнований"
            }
          />
        </div>
        {localSports.map((x, i) => (
          <div
            key={x.id}
            className={
              !i
                ? classes.competitionFlexChilds
                : classes.competitionDeleteChilds
            }
          >
            <Select
              options={sports
                .filter(
                  (x) => !insurance.pickedSports.map((i) => i.id).includes(x.id)
                )
                .sort((a, b) => a.title.localeCompare(b.title))}
              onSelect={handleSelect}
              input={{
                placeholder: "Вид спорта",
                className: classes.sportInput,
                value: x.value || x.title,
                // type: 'search'
              }}
              disableRipple
              button={{
                label: localSports.length === i + 1 ? "+" : "x",
                className:
                  localSports.length === i + 1
                    ? classes.blueButton
                    : classes.deleteButton,
                onClick:
                  localSports.length === i + 1
                    ? addLocalSport
                    : removeLocalSport(x.id),
              }}
            />
          </div>
        ))}
      </div>
      <div className={classes.item}>
        <p className={classes.itemTitle}>Страховое покрытие</p>
        <p className={classes.insuranceValue}>
          {new Intl.NumberFormat("ru-RU").format(slider)} ₽
        </p>
        <Slider
          step={100000}
          min={insurance.minInsuranceCoverage}
          max={insurance.maxInsuranceCoverage}
          value={slider}
          onChangeCommitted={changeCoverage}
          classes={{
            root: classes.slider,
            thumb: classes.sliderThumb,
            rail: classes.rail,
            track: classes.sliderTrack,
          }}
          onChange={(e, c) => {
            changeSlider(c);
          }}
          aria-labelledby="continuous-slider"
        />
      </div>
      <div className={classes.item}>
        <p className={classes.itemTitle}>Страховой пакет</p>
        <div className={classes.packages}>
          <div
            onClick={changePacket(2)}
            className={cs(
              classes.packageItem,
              insurance.packet.id === 2 && classes.packageItemActive
            )}
          >
            <Icons level={1} />
            <p className={classes.packageTitle}>Усиленная защита</p>
          </div>
          <div
            onClick={changePacket(3)}
            className={cs(
              classes.packageItem,
              insurance.packet.id === 3 && classes.packageItemActive
            )}
          >
            <Icons level={2} />
            <p className={classes.packageTitle}>Максимальная защита</p>
          </div>
          <div
            onClick={changePacket(4)}
            className={cs(
              classes.packageItem,
              insurance.packet.id === 4 && classes.packageItemActive
            )}
          >
            <Icons level={3} />
            <p className={classes.packageTitle}>Профессиональная защита</p>
          </div>
        </div>
        <p>Включает в себя</p>
        <ul className={classes.includes}>
          {insurance.packet.includeList.map((x) => (
            <li className={classes.includesItem} key={x}>
              <p>{x}</p>
            </li>
          ))}
        </ul>
      </div>
    </React.Fragment>
  );
};

export default Insurance;
